<template>
  <div>
    <div
      v-if="block.basicTextEyebrow || block.description || blockTitle"
      :class="`lp__block--basicText__globals lp__block--basicText--${block.textAlignment}`"
    >
      <h4 class="c_2022--body-sm" v-if="block.basicTextEyebrow">{{ block.basicTextEyebrow }}</h4>
      <h2 class="c_2022--h3_graphik" v-if="blockTitle">{{ blockTitle }}</h2>
      <div
        class="c_lp_text_block__text c_text lp__block--basicText__globals__description"
        v-if="block.description"
        v-html="block.description"
      ></div>
    </div>
    <div
      class="c_basic_text__container"
      :class="{
        c_grid: block.columns !== '1',
        'lp__block--basicText--2_column': block.columns === '2',
        'lp__block--basicText--3_column': block.columns === '3',
        'c_grid--2': block.columns === '2',
        'c_grid--2-3': block.columns === '3',
      }"
      v-if="block.textBlocks?.length"
    >
      <BasicTextBlock
        :button-link-field="parseLinkField(item.primaryCtaBtn, 'superTable').valid ? item : null"
        :buttons="item.blockButtons || null"
        :eyebrow="item.eyebrow || null"
        :eyebrow-style="block.columns !== '1' ? 'regular' : null"
        :subheader="item.subheader || null"
        :text="item.text || null"
        :text-alignment="item.textAlignment || null"
        :primary-cta-btn="item.primaryCtaBtn || null"
        :primary-cta-btn-label="item.primaryCtaBtnLabel || null"
        :primary-cta-btn-aria-label="item.primaryCtaBtnAriaLabel || null"
        :primary-cta-btn-theme="item.primaryCtaBtnTheme || 'primary'"
        :primary-cta-btn-open-in-a-new-window="item.primaryCtaBtnOpenInANewWindow || null"
        :btn-custom-url="item.custom || null"
        :btn-label="item.buttonLabel || null"
        :btn-aria-label="item.ariaLabel || null"
        :entry="item.entry || null"
        :asset="item.asset || null"
        :secondary-cta-btn-theme="item.secondaryButtonTheme || 'primary'"
        :product-category="item.productCategory || null"
        v-for="(item, index) in block.textBlocks"
        :key="index"
        :colors="block.colors"
      />
    </div>
    <div
      v-if="block.buttons?.length"
      class="c_lp_text lp__block--basicText__buttons"
      :class="`c_lp_text__buttons--${block.colors}`"
    >
      <Button
        v-for="(button, index) in block.buttons"
        :key="index"
        class="c_button_2022"
        :class="getGlobalButtonTheme(button)"
        unstyle
        v-if="button?.buttonUrl"
        :href="button?.buttonUrl"
        :new-window="button?.openInANewTab"
        :aria-label="button?.buttonLabel"
      >
        {{ button?.buttonLabel }}
        <div v-if="button.buttonTheme === 'externalLink'">
          <IconSVG width="14" height="14" handle="new_window" />
        </div>
      </Button>
    </div>
    <div
      class="lp__block--basicText__globals__description lp__block--basicText__globals__buttons c_lp_text_block__text c_text"
      :class="`lp__block--basicText__globals__buttons--${block.textAlignment}`"
      v-if="block.mainButtons"
    >
      <div v-html="block.mainButtons"></div>
    </div>
  </div>
</template>

<script>
import { parseLinkField } from 'JS/global.js';
import BasicTextBlock from './BasicTextBlock.vue';
import { defineComponent, toRefs, reactive } from '@nuxtjs/composition-api';
import IconSVG from 'Components/icon_svg/IconSVG.vue';
import Button from 'Components/button/Button.vue';

export default defineComponent({
  name: 'BasicText',
  components: {
    BasicTextBlock,
    Button,
    IconSVG,
  },
  props: {
    block: { type: Object },
  },
  setup(props) {
    const state = reactive({
      btnClasses: {
        primary: 'c_button_2022 c_button_2022--primary',
        secondary: 'c_button_2022 c_button_2022__secondary',
        externalLink: 'c_button_2022 c_button_2022__external',
      },
      blockTitle: { type: String, default: '' },
    });

    // Different entry types have different field handles for title
    state.blockTitle = props.block.basicTextTitle || props.block.pageTitle || '';

    // Override display title if set by CMS
    // if (props.block.__typename && props.block.__typename === 'bodyContent2022_basicText_BlockType') {
    //   state.displayTitle = props.block.displayTitle;
    // }

    const getGlobalButtonTheme = (btn) => {
      return state.btnClasses[btn.buttonTheme];
    };
    return { ...toRefs(state), parseLinkField, getGlobalButtonTheme };
  },
});
</script>

<style lang="scss">
.lp__block--basicText__globals {
  margin-bottom: px_to_rem(48);
  @include mq($mq_sm_to_md) {
    margin-bottom: px_to_rem(21);
  }
  .lp__block--basicText__globals__description {
    margin: px_to_rem(12) 0 px_to_rem(32);
    p {
      max-width: px_to_rem(800);
    }
  }
  &__buttons {
    margin-top: px_to_rem(30);
    margin-bottom: px_to_rem(30);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p {
      display: flex;
      flex-flow: wrap;
      gap: px_to_rem(20);
      a:not(.c_button_2022) {
        display: flex;
        align-items: center;
      }
    }

    &--left {
      margin-right: auto;
      justify-content: flex-start;
    }
    &--center {
      margin-left: auto;
      margin-right: auto;
      justify-content: center;
    }
    &--right {
      margin-left: auto;
      justify-content: flex-end;
    }
  }
}
.c_basic_text__container {
  & > div {
    margin-bottom: px_to_rem(30);
    @include mq($mq_sm_to_md) {
      margin-bottom: px_to_rem(50);
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.lp__block--basicText.lp__block_2023 {
  @include font('graphik_regular');
  h4 {
    @include font('graphik_medium');
    margin-bottom: px_to_rem(10);
  }
  .lp__block--basicText--left {
    text-align: left;
    @include mq($mq_sm_to_md) {
      text-align: left;
    }
    & ~ .lp__block--basicText__buttons {
      justify-content: flex-start;
    }
    .lp__block--basicText__globals__description {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  .lp__block--basicText--center {
    text-align: center;
    @include mq($mq_sm_to_md) {
      text-align: center;
    }
    & ~ .lp__block--basicText__buttons {
      justify-content: center;
    }
    .lp__block--basicText__globals__description {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    ul,
    ol {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .lp__block--basicText--right {
    text-align: right;
    @include mq($mq_sm_to_md) {
      text-align: right;
    }
    & ~ .lp__block--basicText__buttons {
      justify-content: flex-end;
    }
    .lp__block--basicText__globals__description {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
    }
  }
  h2 {
    @include fs_lh(32, 40, 24, 30);
    @include font('graphik_semibold');
  }
  p,
  strong,
  li,
  em {
    @include fs_lh(18, 28, 16, 28);
  }
  .c_lp_text__eyebrow {
    @include fs_lh(16, 21, 14, 18);
    @include font('graphik_medium');
    opacity: 1;
    margin-bottom: px_to_rem(5);
  }
  .c_lp_text {
    max-width: 100%;
  }
  .lp__block--basicText__buttons {
    margin-top: px_to_rem(48);
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: px_to_rem(20);

    .c_button_2022 {
      display: flex;
      align-items: center;
      gap: px_to_rem(9);
    }
  }
  .c_lp_text__buttons {
    &--whiteTextBlackBackground {
      .c_button_2022__secondary {
        border-color: $color_white;
        &:hover {
          background-color: $color_white;
          color: $color_black;
        }
      }
      .c_button_2022__external {
        color: $color_white;
      }
    }
    &--blackTextWhiteBackground {
      .c_button_2022__secondary {
        color: $color_red;
        &:hover {
          color: $color_white;
        }
      }
    }
    &--blackTextYellowBackground {
      .c_button_2022__secondary {
        border-color: $color_black;
        color: $color_black;
        &:hover {
          background-color: $color_black;
          color: $color_white;
        }
      }
      .c_button_2022__external {
        color: $color_black;
      }
    }
    &--blackTextGrayBackground {
      .c_button_2022__secondary {
        color: $color_black;
        border-color: $color_black;
        &:hover {
          background-color: $color_black;
          color: $color_white;
        }
      }
      .c_button_2022__external {
        color: $color_black;
      }
    }
    &--whiteTextDarkGrayBackground {
      .c_button_2022__secondary {
        border-color: $color_white;
        color: $color_white;
        &:hover {
          background-color: $color_white;
          color: $color_black;
        }
      }
      .c_button_2022__external {
        color: $color_white;
      }
    }
  }
}
</style>
